export default __webpack_public_path__ + "static/2004-logo-910e624ad71227472d26d7caa2303f57.png";